import { Link } from 'react-router-dom';
import { services } from '@/mocks/homeData';

export default function ServicesSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            核心服务
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            全方位足球体验
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            从赛事直播到数据分析，从互动玩法到资讯速递，开云足球为您打造一站式足球服务平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.link}
              className="group p-6 md:p-7 rounded-2xl bg-background-50 hover:bg-primary-50/50 transition-all duration-300 flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-5">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {service.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {service.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}